import { render, staticRenderFns } from "./PhysicianListFilters.vue?vue&type=template&id=6bb3dd54&"
import script from "./PhysicianListFilters.vue?vue&type=script&lang=js&"
export * from "./PhysicianListFilters.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports